import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppInit } from '@us/web/shared/app';
import { filter, first, merge, switchMap, tap } from 'rxjs';
import { PreferenceActions } from './preference.actions';
import { selectLanguage } from './preference.reducer';
import { selectDefaultLanguage } from '@us/web/shop/data-access';
import { tuiIsPresent } from '@taiga-ui/cdk';

@Injectable()
export class PreferenceEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly translocoService = inject(TranslocoService);

    initLanguage$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(AppInit),
                switchMap(() =>
                    merge(this.store.select(selectLanguage), this.store.select(selectDefaultLanguage)).pipe(
                        filter(tuiIsPresent),
                        first()
                    )
                ),
                tap(language => {
                    this.translocoService.setActiveLang(language as string);
                    this.store.dispatch(PreferenceActions.patchPreference({ language }));
                })
            );
        },
        { dispatch: false }
    );

    changeLanguage$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(PreferenceActions.patchPreference),
                filter(preference => 'language' in preference),
                tap(({ language }) => {
                    this.translocoService.setActiveLang(language as string);
                })
            );
        },
        { dispatch: false }
    );
}
